import { createReducer, on } from '@ngrx/store';

import * as sessionActions from '../actions/session.actions';
import * as usersActions from '../actions/users.actions';
import { initialUsersState } from '../states';

export const USERS_REDUCER_KEY = 'users';

export const USERS_REDUCER = createReducer(
    initialUsersState,
    on(usersActions.SetUserSettings, (state, action) => {
        return {
            ...state,
            settings: {
                passwordPolicy: action?.passwordPolicy,
                passwordPolicyMsg: action?.passwordPolicyMsg,
                settingsFailedMessage: undefined,
            },
        };
    }),
    on(usersActions.GetUserSettingsFailed, (state, action) => {
        return {
            ...state,
            settings: {
                passwordPolicy: undefined,
                passwordPolicyMsg: undefined,
                settingsFailedMessage: action?.msg,
            },
        };
    }),
    on(usersActions.UpdatePassword, state => {
        return {
            ...state,
            passwordUpdate: {
                message: undefined,
            },
        };
    }),
    on(usersActions.ClearUpdatePasswordSuccessfullMessage, state => {
        return {
            ...state,
            passwordUpdate: {
                message: undefined,
            },
        };
    }),
    on(usersActions.UpdatePasswordSuccessfull, (state, action) => {
        return {
            ...state,
            passwordUpdate: {
                message: action.message,
            },
        };
    }),
    on(usersActions.SetUsersPagination, (state, action) => {
        return {
            ...state,
            usersPagination: {
                ...state.usersPagination,
                index: action.pageNumber,
                pageSize: action.pageSize,
            },
        };
    }),
    on(usersActions.ClearUsersSearch, (state, action) => {
        return {
            ...state,
            search: action.search,
            usersPagination: {
                ...state.usersPagination,
                index: 0,
                pageSize: 0,
            },
        };
    }),
    on(usersActions.SetUsersSearch, (state, action) => {
        return {
            ...state,
            search: action.search,
            usersPagination: {
                ...state.usersPagination,
                index: 0,
            },
        };
    }),
    on(usersActions.SetUsers, (state, action) => {
        const organizationId = action.organizationId;
        const search = JSON.stringify(state.search);
        const existingList: (string | null)[] = [...(state.usersList[`${organizationId}|${search}`] || [])];
        let usersList: (string | null)[];
        if (action.pageNumber !== undefined && action.pageNumber > 0) {
            const startIndex = (action.pageNumber - 1) * state.usersPagination.pageSize;
            while (existingList.length < startIndex) {
                existingList.push(null);
            }
            action.data.forEach((user, i) => {
                existingList[startIndex + i] = user.id;
            });
            usersList = existingList;
        } else {
            const newUsersList = action.data.map(user => user.id);
            usersList = [...new Set([...existingList.filter(id => id !== null), ...newUsersList])];
        }
        return {
            ...state,
            usersList: {
                ...state.usersList,
                [`${organizationId}|${search}`]: usersList,
            },
            usersMap: {
                ...state.usersMap,
                ...action.data.reduce((usersMap, user) => {
                    usersMap[user.id] = user;
                    return usersMap;
                }, {}),
            },
            usersPagination: {
                ...state.usersPagination,
                count: action.count !== undefined ? action.count : state.usersPagination.count,
            },
        };
    }),
    on(usersActions.SetUser, (state, action) => {
        const search = JSON.stringify(state.search);
        const userId = action.user?.id;
        if (!userId) {
            return state;
        }
        if (action.newUser) {
            return {
                ...state,
                usersList: {
                    ...state.usersList,
                    [`${action.organizationId}|${search}`]: [...(state.usersList[`${action.organizationId}|${search}`] || []), userId],
                },
                usersMap: {
                    ...state.usersMap,
                    [userId]: action.user,
                },
            };
        }
        return {
            ...state,
            usersMap: {
                ...state.usersMap,
                [userId]: action.user,
            },
        };
    }),

    on(usersActions.SetAllUsers, (state, action) => {
        return {
            ...state,
            allUsersMap: {
                ...state.allUsersMap,
                ...action.users.reduce((usersMap, user) => {
                    usersMap[user.id] = user;
                    return usersMap;
                }, {}),
            },
        };
    }),

    on(usersActions.SetSelectedOrgId, (state, action) => {
        return {
            ...state,
            selectedOrgIdToAssignUsers: action.orgId,
        };
    }),
    on(usersActions.SetOrgUsers, (state, action) => {
        return {
            ...state,
            organizationUsers: {
                ...state.organizationUsers,
                [action.orgId]: action.users,
            },
        };
    }),
    on(usersActions.SetProviderUsers, (state, action) => {
        return {
            ...state,
            providerUsers: action.users,
        };
    }),
    on(usersActions.SetTimeBoundUsersList, (state, action) => {
        return {
            ...state,
            timeBoundUsersList: action.users,
        };
    }),
    on(sessionActions.SessionLogoutSuccessfull, () => initialUsersState)
);
